export const FETCH_FACEBOOK_CAMPAIGNS = "FETCH_FACEBOOK_CAMPAIGNS";
export const FETCH_FACEBOOK_CAMPAIGNS_SUCCESS = "FETCH_FACEBOOK_CAMPAIGNS_SUCCESS";
export const FETCH_FACEBOOK_CAMPAIGNS_FAILED = "FETCH_FACEBOOK_CAMPAIGNS_FAILED";

export const LOAD_FACEBOOK_CAMPAIGNS = "LOAD_FACEBOOK_CAMPAIGNS";
export const LOAD_FACEBOOK_CAMPAIGNS_SUCCESS = "LOAD_FACEBOOK_CAMPAIGNS_SUCCESS";
export const LOAD_FACEBOOK_CAMPAIGNS_FAILED = "LOAD_FACEBOOK_CAMPAIGNS_FAILED";